// import logo from './logo.svg';
import './App.css';
// import Menu from './components/Menu.js';
// import Header from './components/Header.js';
import Dashboard from './Pages/Dashboard.js';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import OrdersForms from './Pages/OrdersForms.js';
import AvailableMenu from './Pages/AvailableMenu.js';
import TotalOrder from './Pages/TotalOrder.js';
import Historical from './Pages/Historical.js';
import SeeMore from './Pages/SeeMore.js';
import Inscription from './Pages/Auth/Inscription.js';
import Connexion from './Pages/Auth/Connexion.js';
import Montre from './Montre.js';
// import ProtectedRoute from './components/ProtectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import PendingOrders from './Pages/PendingOrders.js';
import OrderInProgress from './Pages/OrderInProgress.js';
import OrderDelivered from './Pages/OrderDelivered.js';
import OrderCancelled from './Pages/OrderCancelled.js';
import Table from './components/Table.js';
import About from './Pages/About.js';
import Home from './Pages/Home.js';
import ResetPassword from './Pages/Auth/ResetPassword.js';
import ContactSupport from './Pages/ContactSupport.js';

import { useEffect, useState } from 'react';


function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('token') !== null);
 

  return (
    <Router>

      <div className="App">

        <Routes>
        <Route path="/" element={<Home setIsAuthenticated={setIsAuthenticated} />} />
          <Route path='/dashboard' element={ isAuthenticated ? (<Dashboard setIsAuthenticated={setIsAuthenticated} />) : (<Navigate to="/connexion"/>)} />
          <Route path="/new_order" element={isAuthenticated ? <OrdersForms /> : (<Navigate to="/connexion"/>)} />
          <Route path="/available_menu" element={isAuthenticated ? <AvailableMenu /> : (<Navigate to="/connexion"/>)} />
          <Route path="/total_order" element={<TotalOrder />} />
          <Route path="/historical" element={isAuthenticated ? <Historical /> : (<Navigate to="/connexion"/>)} />
          <Route path="/see_more/:id" element={isAuthenticated ? <SeeMore /> : (<Navigate to="/connexion"/>)} />
          <Route path="/Inscription" element={<Inscription />} />
          <Route path="/show" element={<Montre />} />
          <Route path="/connexion" element={<Connexion setIsAuthenticated={setIsAuthenticated} isAuthenticated={isAuthenticated} />} />
          <Route path="/pending_orders" element={isAuthenticated ? <PendingOrders /> : (<Navigate to="/connexion"/>)} />
          <Route path="/orders_in_progress" element={isAuthenticated ? <OrderInProgress /> : (<Navigate to="/connexion"/>)} />
          <Route path="/orders_delivered" element={isAuthenticated ? <OrderDelivered /> : (<Navigate to="/connexion"/>)} />
          <Route path="/orders_cancelled" element={isAuthenticated ? <OrderCancelled /> : (<Navigate to="/connexion"/>)} />
          <Route path="/tableau" element={<Table />} />
          <Route path="/about" element={<About />} />
          <Route path="/reset_password" element={ isAuthenticated ? (<ResetPassword />) : (<Navigate to="/connexion"/>)} />
          <Route path="/contact_support" element={ isAuthenticated ? (<ContactSupport />) : (<Navigate to="/connexion"/>)} />
        </Routes>
      </div>

    </Router>
  );
}

export default App;
